import React from "react";
import { LocationOn } from "@material-ui/icons";
import styled, { withTheme } from "styled-components";

import Button from "common/Button";
import { useSetSearchQuery } from "utils/useQuery";

const BatchEdit = styled.div`
  position: absolute;
  bottom: 5px;
  width: 100%;
  height: 70px;
  background-color: ${({ theme }) => theme.whiteBackground}};
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  gap: 5px;
  border-top: 1px solid #e7e7e7;
`;

function BatchEditComp({ setSelectedRoute, setToggleModal, theme }) {
  const { setSearchQuery } = useSetSearchQuery();
  return (
    <BatchEdit>
      <Button
        onClick={() => setSelectedRoute([])}
        color={theme.interactionColor}
        background={theme.whiteBackground}
        title="Auswahl aufheben"
        alt="Auswahl aufheben"
        text="Auswahl aufheben"
        textSize="14px"
      />
      <div style={{ height: "100%", width: "1px", backgroundColor: "#e7e7e7" }}></div>
      <Button
        onClick={() => {
          setSearchQuery({ fromCompanySearch: true });
          setToggleModal(6);
        }}
        color={theme.primaryColor}
        background={theme.whiteBackground}
        Icon={LocationOn}
        textSize="14px"
        iconSize="20px"
        title="Weiter zur Routenplanung"
        alt="Weiter zur Routenplanung"
        text="Weiter zur Routenplanung"
      />
    </BatchEdit>
  );
}

export default withTheme(BatchEditComp);
